module.exports = __webpack_public_path__ + "static/img/blog_good_3.2fa7c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_3.png
// module id = PL9S
// module chunks = 8